<template>
  <el-cascader
      ref="cascaderPanelSearch"
      v-model="selectedValue"
      :options="options"
      :props="cascaderProps"
      clearable
      filterable
      @change="handleChange"
  ></el-cascader>
</template>
<script>
import { getLockReason } from '@/api/basic/customer'

export default {
  name: 'd2-container-cascader-panel-search',
  data () {
    return {
      selectedValue: '',
      options: [],
      cascaderProps: {
        checkStrictly: true,
        emitPath: false,
        expandTrigger: 'click',
        value: 'reasonLabel',
        label: 'reasonLabel'
      }
    }
  },
  props: {},
  methods: {
    initMsg () {
      getLockReason().then(res => {
        if (res.code === 0) {
          this.options = res.data.map(item => this.removeEmptyChildren(item))
          console.log('this.options', this.options)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    removeEmptyChildren (node) {
      // 浅拷贝节点，避免直接修改原数据
      const newNode = { ...node }

      // 如果存在 children 且是数组
      if (newNode.children && Array.isArray(newNode.children)) {
        if (newNode.children.length === 0) {
          // 移除空 children
          delete newNode.children
        } else {
          // 递归处理子节点
          newNode.children = newNode.children.map(child => this.removeEmptyChildren(child))
        }
      }

      return newNode
    },
    // 通过 change 事件验证
    handleChange (val) {
      console.log('handleChange', val)
      this.$emit('change', val)
      // this.judgeIsComplete()
    }
  },
  watch: {
    selectedValue: function (val, oldVal) {
      console.log('watch', val)
      this.$emit('input', val)
    }
  },
  mounted () {
    this.initMsg()
  }
}
</script>

<style lang="scss" scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-cascader-panel-search/index.vue"
}
</vue-filename-injector>
